export enum BulkPassengerNearbySearchFormFieldsEnum {
  distanceInMeters = "distanceInMeters",
}
